import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Catalog } from './pages/Catalog';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { DtfPrinting } from './pages/DtfPrinting';
import { ScreenPrinting } from './pages/ScreenPrinting';
import { CustomApparel } from './pages/CustomApparel';
import { CustomBanners } from './pages/CustomBanners';
import { BusinessCards } from './pages/BusinessCards';
import { BusinessWorkwear } from './pages/BusinessWorkwear';
import { TeamApparel } from './pages/TeamApparel';
import { UploadGangSheet } from './pages/UploadGangSheet';
import { CustomKeyTags } from './pages/CustomKeyTags';
import { SEOStrip } from './components/SEOStrip';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen bg-atomic-black text-white selection:bg-atomic-green selection:text-black" data-id="element-1">
        <SEOStrip data-id="element-2" />
        <Header data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
          <Route path="/catalog" element={<Catalog data-id="element-10" />} data-id="element-9" />
          <Route path="/contact" element={<Contact data-id="element-12" />} data-id="element-11" />
          <Route path="/faq" element={<FAQ data-id="element-14" />} data-id="element-13" />
          <Route path="/dtf-printing" element={<DtfPrinting data-id="element-16" />} data-id="element-15" />
          <Route path="/screen-printing" element={<ScreenPrinting data-id="element-18" />} data-id="element-17" />
          <Route path="/upload-gang-sheet" element={<UploadGangSheet data-id="element-20" />} data-id="element-19" />
          <Route path="/custom-apparel" element={<CustomApparel data-id="element-22" />} data-id="element-21" />
          <Route path="/custom-banners" element={<CustomBanners data-id="element-24" />} data-id="element-23" />
          <Route path="/business-cards" element={<BusinessCards data-id="element-26" />} data-id="element-25" />
          <Route path="/business-workwear" element={<BusinessWorkwear data-id="element-28" />} data-id="element-27" />
          <Route path="/team-apparel" element={<TeamApparel data-id="element-30" />} data-id="element-29" />
          <Route path="/custom-key-tags" element={<CustomKeyTags data-id="element-32" />} data-id="element-31" />
        </Routes>
        <Footer data-id="element-33" />
      </div>
    </Router>;
}
export { App };